module.exports = __webpack_public_path__ + "img/2.c9f037b8.png";